import * as React from "react";

import styles from "./HighlightedCsvBody.module.css";
import { parseCsv } from "./parseCsv";

interface HighlightedCsvBodyProps {
  code: string;
}

const COLUMN_COLOR_COUNT = 6;

/**
 * Renders CSV with each cell colored by its column index, cycling through
 * {@link COLUMN_COLOR_COUNT} hues so columns are visually distinguishable.
 * Used as the `language === "csv"` branch of `HighlightedCodeBody`. Parsing
 * lives in {@link parseCsv}.
 */
export const HighlightedCsvBody: React.FC<HighlightedCsvBodyProps> = ({
  code,
}) => {
  const rows = React.useMemo(() => parseCsv(code), [code]);

  return (
    <code className={styles.csv}>
      {rows.map((row, rowIdx) => (
        <React.Fragment key={rowIdx}>
          {row.map((cell, colIdx) => (
            <React.Fragment key={colIdx}>
              <span className={styles[`col${colIdx % COLUMN_COLOR_COUNT}`]}>
                {cell}
              </span>
              {colIdx < row.length - 1 ? "," : null}
            </React.Fragment>
          ))}
          {rowIdx < rows.length - 1 ? "\n" : null}
        </React.Fragment>
      ))}
    </code>
  );
};
